import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Typography,
  IconButton,
  Tooltip,
  Popper,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ClickAwayListener
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
// import MoreIcon from '@material-ui/icons/MoreVert';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.white,
    padding: theme.spacing(2),
    height: 68,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  backButton: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto',
    overflow: 'hidden',
    '& > h6': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  moreButton: {
    marginLeft: theme.spacing(2)
  },
  popper: {
    zIndex: theme.zIndex.tooltip + 100
  },
}));

const Toolbar = props => {
  const {
    group,
    onBack,
    open,
    handleRefresh,
    className,
    ...rest
  } = props;

  const classes = useStyles();
  const optionRef = useRef(null);
  const [openPopover, setOpenPopover] = useState(false);

  const handlePopverClose = () => {
    setOpenPopover(false);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Tooltip title="Back">
        <IconButton
          className={classes.backButton}
          onClick={onBack}
          size="small"
        >
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>
      <div className={classes.title}>
        <Typography variant="h6">{open ? `Manage Group: ${group.name}` : 'Manage Groups'}</Typography>
      </div>
      {open &&
        <Tooltip title="Refresh">
          <IconButton
            onClick={handleRefresh(group)}
            size="small"
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>}
      {/* <Tooltip title="More options">
        <IconButton
          className={classes.moreButton}
          onClick={() => setOpenPopover(true)}
          ref={optionRef}
          size="small"
        >
          <MoreIcon />
        </IconButton>
      </Tooltip> */}
      <Popper
        anchorEl={optionRef.current}
        className={classes.popper}
        open={openPopover}
        transition
      >
        <ClickAwayListener onClickAway={handlePopverClose}>
          <Paper elevation={3}>
            <List>
              <ListItem
                button
                onClick={handlePopverClose}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Edit" />
              </ListItem>
              <ListItem
                button
                onClick={handlePopverClose}
              >
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>
                <ListItemText primary="Delete" />
              </ListItem>
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  group: PropTypes.object,
  handleRefresh: PropTypes.func,
  onBack: PropTypes.func,
  open: PropTypes.bool,
};

export default Toolbar;
